export default __webpack_public_path__ + "static/media/220.9ce08f78.png";